import { render, staticRenderFns } from "./ChartBar2.vue?vue&type=template&id=0f1ca254&scoped=true&lang=pug&"
import script from "./ChartBar2.vue?vue&type=script&lang=js&"
export * from "./ChartBar2.vue?vue&type=script&lang=js&"
import style0 from "./ChartBar2.vue?vue&type=style&index=0&id=0f1ca254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ca254",
  null
  
)

export default component.exports